import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../apiClient";

export const postBus = data => {
  return api.post(`/admin/buses-v2`, data);
};

export const usePostBusMutation = ({ mutationConfig } = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: postBus,
    onSuccess: async (data, ...args) => {
      if (onSuccess) {
        await onSuccess(data, ...args);
      }
      queryClient.resetQueries({
        queryKey: ["buses"],
      });
    },
    ...restConfig,
  });
};
